// composables/useDealerGrouping.js
import { computed } from 'vue'

export function useDealerGrouping(dealersLocations) {
  const groupedDealers = computed(() => {
    if (!dealersLocations.value || dealersLocations.value.length === 0) {
      return []
    }

    // Group dealers by dealerId
    const dealerGroups = new Map()
    
    dealersLocations.value.forEach(dealer => {
      const dealerId = dealer.dealerId
      
      if (!dealerGroups.has(dealerId)) {
        dealerGroups.set(dealerId, {
          dealerId: dealer.dealerId,
          dealerName: dealer.dealerName,
          websiteUrl: dealer.websiteUrl,
          onlineRetailer: dealer.onlineRetailer,
          primaryLocation: dealer, // First location (usually closest) becomes primary
          additionalLocations: [],
          hasMultipleLocations: false
        })
      } else {
        // Add to additional locations
        dealerGroups.get(dealerId).additionalLocations.push(dealer)
        dealerGroups.get(dealerId).hasMultipleLocations = true
      }
    })

    // Convert Map to array and sort by distance of primary location
    return Array.from(dealerGroups.values()).sort((a, b) => {
      const distanceA = a.primaryLocation.distance
      const distanceB = b.primaryLocation.distance
      
      if (distanceA === null && distanceB === null) return 0
      if (distanceA === null) return 1
      if (distanceB === null) return -1
      
      return distanceA - distanceB
    })
  })

  return {
    groupedDealers
  }
}
